import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { ChatMessage } from 'components';
import moment from 'moment';
import * as styles from './ChatPopup.scss';

function ChatPopup(props) {
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
      feedbackThread = props.feedbackThread,
      handlePostFeedback = props.handlePostFeedback,
      _props$title = props.title,
      title = _props$title === void 0 ? 'Draft Feedback' : _props$title,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      user = props.user;

  var _useState = useState(open),
      _useState2 = _slicedToArray(_useState, 2),
      expand = _useState2[0],
      setExpand = _useState2[1];

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var messages = feedbackThread && feedbackThread.FeedbackMessages && feedbackThread.FeedbackMessages.length ? feedbackThread.FeedbackMessages : [];

  var handleChange = function handleChange(e) {
    setValue(e.target.value);
  };

  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  var handleSubmit = function handleSubmit() {
    handlePostFeedback(value);
    setValue(defaultValue);
  };

  useEffect(function () {
    setExpand(open);
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(styles.floatingChat, " ").concat(expand ? styles.expand : ''),
    id: "test-chatpopup-bubble",
    onClick: function onClick() {
      if (!expand) {
        setExpand(true);
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-comments",
    "aria-hidden": "true",
    style: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: " ".concat(styles.chat, " ").concat(expand ? styles.expand : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setExpand(false);
    }
  }, "\xD7")), /*#__PURE__*/React.createElement("ul", {
    className: styles.messages
  }, messages && messages.length ? messages.map(function (message) {
    if (!user) return false;
    var myMessage = parseInt(message.ownerUserId) === parseInt(user.id);
    var formattedTimestamp = moment(message.createdAt).format('dddd, M/DD/YYYY h:mm a');
    return /*#__PURE__*/React.createElement(ChatMessage, {
      style: myMessage ? {
        alignSelf: 'flex-end'
      } : {},
      message: message,
      time: formattedTimestamp,
      self: myMessage
    });
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: styles.chatInputWrap
  }, /*#__PURE__*/React.createElement("input", {
    onChange: handleChange,
    onKeyPress: handleOnKeyDown,
    type: "text",
    className: styles.chatInput,
    placeholder: "Send a message...",
    value: value
  }), /*#__PURE__*/React.createElement("i", {
    className: " icon ion-android-send ".concat(styles.chatInputButton),
    onClick: handleSubmit,
    id: "submitBtn"
  }))));
}

export default ChatPopup;